import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { AlarmNotificationProfile, AdaptedAlarmNotificationProfile } from 'data/alarmNotificationProfile/alarmNotificationProfile.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  AlarmNotificationProfileData: AdaptedAlarmNotificationProfile,
  originalAlarmNotificationProfileFormData: AdaptedAlarmNotificationProfile | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.ALARM_NOTIFICATION_PROFILE_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.ALARM_NOTIFICATION_PROFILE_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(AlarmNotificationProfileData, null, isEdit, originalAlarmNotificationProfileFormData),
    AlarmNotificationProfileData.name,
    AuditService.ALARM_NOTIFICATION_PROFILE,
    actionType,
  );
  return auditDetails as AuditDetails;
}
